/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
// import moment from 'moment'

const useFilters = () => {
  const { t } = useTranslation()

  
  const filters = useMemo(() => {
    const result = [
      {
        accessor: 'name',
        label: t('fieldData.name')
      },
      {
        accessor: 'type',
        label: t('fieldData.type')
      },
      {
        accessor: 'localization',
        label: t('fieldData.localization')
      },
      {
        accessor: 'created',
        label: t('fieldData.created'),
        // formatter: value => value ? moment.utc(value).format('DD/MM/YYYY') : ''
      }
    ]
    return result
  }, [t])

  return filters
}

export default useFilters